/**
 * Central configuration for TanStack Query cache times.
 * All staleTime values should reference these constants instead of inline magic numbers.
 *
 * - DEFAULT: Used for entity data (orders, customers, etc.)
 *   Applied globally in App.tsx — hooks that don't set staleTime inherit this.
 *
 * - METADATA: Used for data that rarely changes (field restrictions, enum types,
 *   search metadata, workflow definitions, entity schemas).
 */
export const CACHE_TIME = {
  /** 30 seconds — for entity data that may change between navigations */
  DEFAULT: 30_000,
  /** 5 minutes — for metadata/config that rarely changes during a session */
  METADATA: 5 * 60 * 1000,
} as const;
